"use strict";
'use es6'; // Prevent unwanted focus styles

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

require("../listeners/focusStylesListener");

var _I18n = _interopRequireDefault(require("I18n"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Functions = require("../core/Functions");

var _validHref = _interopRequireDefault(require("../utils/propTypes/validHref"));

var _UnsafeUrl = require("../utils/UnsafeUrl");

var _Links = require("../utils/Links");

var _TabIndex = require("../utils/TabIndex");

var _LinkConstants = require("./LinkConstants");

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _UITruncateString = _interopRequireDefault(require("../text/UITruncateString"));

var _ClickableContext = require("../context/ClickableContext");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  .private-table tr:not(:hover) .private-link:not(:focus) & {\n    visibility: hidden;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// Hide icon in tables, except on hover (#5679)
var truncatedExternalIconMixin = (0, _styledComponents.css)(_templateObject());
var DefaultExternalIcon = (0, _styledComponents.default)(function (props) {
  var __truncated = props.truncated,
      rest = (0, _objectWithoutProperties2.default)(props, ["truncated"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UILink__DefaultExternalIcon",
  componentId: "dfvllj-0"
})(_templateObject2(), function (_ref) {
  var truncated = _ref.truncated;
  return truncated && truncatedExternalIconMixin;
});

var getClassName = function getClassName(className, disabled, underline, use) {
  return (0, _classNames.default)('private-link', _LinkConstants.UNDERLINE_CLASSES[underline], _LinkConstants.USE_CLASSES[use], {
    'private-link--disabled': disabled
  }, className);
};

var UILinkCore = _react.default.createClass({
  displayName: "UILinkCore",
  mixins: [_reactAddonsPureRenderMixin.default],
  handleKeyDown: function handleKeyDown(evt) {
    // Simulate click on Spacebar, to emulate button behavior
    var key = evt.key;
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onKeyDown = _this$props.onKeyDown,
        onClick = _this$props.onClick;
    (0, _Functions.callIfPossible)(onKeyDown, evt);

    if (typeof onClick !== 'function') {
      return;
    }

    if (key === ' ') {
      if (disabled) {
        evt.preventDefault();
        evt.stopPropagation();
        return;
      }

      onClick(evt); // Prevent scrolling

      evt.preventDefault();
    }
  },
  handleClick: function handleClick(evt) {
    var _this$props2 = this.props,
        onClick = _this$props2.onClick,
        disabled = _this$props2.disabled;

    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _this$props3 = this.props,
        children = _this$props3.children,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        external = _this$props3.external,
        ExternalIcon = _this$props3.ExternalIcon,
        href = _this$props3.href,
        iconProps = _this$props3.iconProps,
        linkRef = _this$props3.linkRef,
        __onClick = _this$props3.onClick,
        __onKeyDown = _this$props3.onKeyDown,
        rel = _this$props3.rel,
        role = _this$props3.role,
        tabIndex = _this$props3.tabIndex,
        target = _this$props3.target,
        truncate = _this$props3.truncate,
        truncateStringProps = _this$props3.truncateStringProps,
        underline = _this$props3.underline,
        use = _this$props3.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props3, ["children", "className", "disabled", "external", "ExternalIcon", "href", "iconProps", "linkRef", "onClick", "onKeyDown", "rel", "role", "tabIndex", "target", "truncate", "truncateStringProps", "underline", "use"]);

    if (this.props.to != null) {
      _devLogger.default.warn({
        message: "UILink: The `to` prop is a no-op. Did you mean `href`? (`to=\"" + this.props.to + "\"`)",
        key: 'UILink: to'
      });
    }

    var computedTarget = (0, _Links.getTarget)(external, target);
    var computedRel = (0, _Links.getRel)(rel, computedTarget);
    var computedRole = href ? undefined : role || 'button';
    var externalLinkIcon = external ? _react.default.createElement(ExternalIcon, (0, _extends2.default)({
      "aria-label": _I18n.default.text('salesUI.UILink.externalTitle'),
      name: "externalLink"
    }, iconProps, {
      className: (0, _classNames.default)('private-link--external__icon', iconProps.className),
      truncated: truncate
    })) : null;
    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UILink');
    var wrappedChildren = truncate ? _react.default.createElement(_UITruncateString.default, (0, _extends2.default)({
      useFlex: true,
      fixedChildren: externalLinkIcon
    }, truncateStringProps), children) : children;

    var renderedLink = _react.default.createElement("a", (0, _extends2.default)({}, rest, {
      className: getClassName(className, disabled, underline, use),
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      href: disabled ? undefined : (0, _UnsafeUrl.getSafeUrl)(href),
      ref: (0, _Functions.wrapRefObject)(linkRef),
      rel: computedRel,
      role: computedRole,
      tabIndex: (0, _TabIndex.getTabIndex)(disabled, tabIndex),
      target: computedTarget,
      "aria-disabled": disabled
    }), wrappedChildren, truncate ? null : externalLinkIcon);

    return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
  }
});

UILinkCore.displayName = 'UILink';

var UILink =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UILink, _React$Component);

  function UILink(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILink);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILink).call(this, props));
    _this._linkRef = _react.default.createRef ? _react.default.createRef() : {
      current: null
    };
    _this.getPortalReporterDetails = _this.getPortalReporterDetails.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UILink, [{
    key: "getPortalReporterDetails",
    value: function getPortalReporterDetails() {
      var linkEl = this._linkRef.current;
      return {
        componentName: UILinkCore.displayName,
        labelText: linkEl && linkEl.innerText
      };
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(_ClickableContext.ClickableContextProvider, {
        value: (0, _ClickableContext.makePortalReporter)(this.getPortalReporterDetails)
      }, _react.default.createElement(UILinkCore, (0, _extends2.default)({
        linkRef: this._linkRef
      }, this.props)));
    }
  }]);
  return UILink;
}(_react.default.Component);

UILink.propTypes = {
  children: _react.PropTypes.node,
  disabled: _react.PropTypes.bool,
  external: _react.PropTypes.bool.isRequired,
  ExternalIcon: _component.default.isRequired,
  href: _validHref.default,
  iconProps: _react.PropTypes.object.isRequired,
  onKeyDown: _react.PropTypes.func,
  rel: _react.PropTypes.string,
  target: _react.PropTypes.string,
  truncate: _react.PropTypes.bool.isRequired,
  truncateStringProps: _react.PropTypes.object.isRequired,
  underline: _react.PropTypes.bool.isRequired,
  use: _react.PropTypes.oneOf(Object.keys(_LinkConstants.USE_CLASSES)).isRequired
};
UILink.defaultProps = {
  external: false,
  ExternalIcon: DefaultExternalIcon,
  iconProps: {},
  truncate: false,
  truncateStringProps: {},
  underline: false,
  use: 'dark'
};
UILink.displayName = 'ProvidesClickableContext(UILink)'; // Expose the inner component for tests

UILink.CoreComponent = UILinkCore;
UILink.WrappedComponent = UILinkCore;
var _default = UILink;
exports.default = _default;
module.exports = exports.default;